import { Controller } from "@hotwired/stimulus"

type ToastShowDetail = {
  message?: string
}

export default class extends Controller<HTMLElement> {
  static targets = ["container", "message"]
  static values = { message: String }

  declare readonly containerTarget: HTMLElement
  declare readonly messageTarget: HTMLElement
  declare readonly messageValue: string

  private hideTimer?: ReturnType<typeof setTimeout>

  connect() {
    if (this.messageValue) this.display(this.messageValue)
  }

  disconnect() {
    clearTimeout(this.hideTimer)
  }

  show(event: Event) {
    this.display((event as CustomEvent<ToastShowDetail>).detail?.message)
  }

  display(message?: string) {
    if (!message) return

    clearTimeout(this.hideTimer)
    this.messageTarget.textContent = message
    this.containerTarget.classList.remove("hidden")
    this.hideTimer = setTimeout(() => {
      this.containerTarget.classList.add("hidden")
    }, 2200)
  }
}
